import { map as _map } from 'lodash';
import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';

class DeliveredVehiclesController {
  constructor(authService, vehicleService, loadingService, lookupService, enums, $q, $window, appConfig, $stateParams) {
    "ngInject";

    if(!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View)) { return; }

    this.authService = authService;
    this.vehicleService = vehicleService;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.enums = enums;
    this.$q = $q;
    this.$window = $window;
    this.appConfig = appConfig;
    this.$stateParams = $stateParams;

    this.filterParams = {};

    this.reset();
  }

  reset() {
    const ctrl = this;

    var startDate = new Date();
    var prev30Days =  startDate.getDate() - 30;
    startDate.setDate(prev30Days);

    this.filterParams.startDate = startDate;
    this.filterParams.endDate = new Date();

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: ctrl.publishMode ? -1 : 10
    };

    this.filterParams.entityId = this.authService.authData.currentLocation.key;
    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'condition',
      ascending: true
    };

    this.notification = {
      type: 'info',
      msg: ''
    };

    this.listVehicles();
  }

  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.listVehicles();
  }

  listVehicles() {
    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('vehicleListing', 'Loading Vehicles ...');

    ctrl.vehicleService.listDeliveredVehicles(ctrl.filterParams)
      .then(response => {
        //response.data.items.map(entity => listCtrl.getActionsDropdown(entity));
        ctrl.vehicles = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} vehicles`
          }
        }
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehicleListing');
      });
  }

  processResult() {
    return {
      stateName: 'deliveredVehicles'
    }
  }
}

export default DeliveredVehiclesController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/deliveredVehicles/deliveredVehicles.controller.js